export const splitArrayIntoNParts = (arr, n) => {
  return arr.reduce((acc, value, idx) => {
    if (idx % n === 0) {
      acc.push([value])
    } else {
      acc[acc.length - 1].push(value)
    }
    return acc
  }, [])
}